import fetch from 'features/common/fetch';

import { setTasksAndInformation } from './slice';

export const fetchTasksAndInformation = () => (dispatch) => {
	dispatch(
		fetch.actions.get(fetch.constants.urls.tasksAndInformation, {
			onSuccess: [
				(response) => () => {
					const body = response?.body;
					dispatch(setTasksAndInformation(body));
				},
			],
		}),
	);
};
